// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"dc233bd7","163":"c1e6e272","419":"b6356849","601":"4c849c4c","787":"2fd5dfea"}[chunkId] + ".chunk.js";
};